module.exports = __webpack_public_path__ + "static/media/3-R-Smart Classic.f38104a8.jpg";